import React, { useEffect, useState } from 'react';
import logo from '../assets/img/or-logo.png';
import NotificationBell from './NotificationBell';
import ProfileMenu from './ProfileMenu';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faGear, faBookOpen } from '@fortawesome/free-solid-svg-icons';
import '../admin-panel.css';
import { usePermissions } from '../PermissionsContext';
import api from '../api/client';
import './header.css'; // Import the new header-specific CSS file

// Пункты меню и разделы, которыми они открываются (ключи из pages.js).
// Группа показывается, если виден хотя бы один её пункт.
const MENU = [
    { page: 'dashboard', label: 'Dashboard', href: '/dashboard' },
    { page: 'general', label: 'General', href: '/general' },
    { page: 'production', label: 'Production', href: '/production' },
    { key: 'inventory', label: 'Inventory', children: [
        { page: 'inventory-materials', label: 'Materials', href: '/inventory-materials' },
        { page: 'inventory-products', label: 'Products', href: '/inventory-products' },
        { page: 'inventory-fba', label: 'FBA Report', href: '/inventory-fba/report' },
    ] },
    { page: 'work-performance', label: 'Work Performance', href: '/work-performance' },
    { key: 'planning', label: 'Planning', wide: true, children: [
        { page: 'material-order-planning', label: 'Monthly Planning', href: '/material-order-planning' },
        { page: 'daily-planning', label: 'Daily Plan', href: '/daily-planning' },
        // Plan to Produce скрыт 08.09.2026 — заменён страницей Production Plan
        // (роут жив, по прямой ссылке /plan-to-produce открывается)
        // Sales Forecast скрыт 31.07.2026 — старая страница, не используется
        // (роут жив, по прямой ссылке /sales-forecast открывается)
        // { page: 'sales-forecast', label: 'Sales Forecast', href: '/sales-forecast' },
        // { page: 'plan-to-produce', label: 'Plan to Produce', href: '/plan-to-produce' },
        { page: 'production-plan', label: 'Production Plan', href: '/production-plan' },
        { page: 'yoy-forecast', label: 'YoY Forecast', href: '/yoy-forecast' },
        { page: 'product-cogs', label: 'Product COGS', href: '/product-cogs' },
        { page: 'material-orders', label: 'Material Orders', href: '/material-orders' },
        { page: 'shipments-planning', label: 'Shipments Planning', href: '/shipments-planning' },
        { page: 'amazon-deals', label: 'Amazon Deals', href: '/amazon-deals' },
    ] },
    { key: 'reports', label: 'Reports', children: [
        { page: 'goods-ordered-report', label: 'Goods Ordered Report', href: '/reports/goods-ordered' },
        { page: 'seeds-receiving-report', label: 'Seeds Receiving Report', href: '/reports/seeds-receiving' },
        { page: 'inventory-consumption-report', label: 'Inventory Consumption Report', href: '/reports/inventory-consumption' },
    ] },
    { page: 'shipments', label: 'Shipments', href: '/shipments' },
    { page: 'scanners', label: 'Scanners', href: '/scanners' },
];

let HeaderLogged = (props) => {
    const [openSubmenu, setOpenSubmenu] = useState(null);
    const { can } = usePermissions();

    // On mobile, submenus open by tap (hover doesn't exist on touch) — this
    // toggle only matters below the 1024px breakpoint, see header.css.
    const toggleSubmenu = (key) => {
        setOpenSubmenu(prev => (prev === key ? null : key));
    };

    const handleLogout = async () => {
        // Сначала чистим хранилище — выход не должен зависеть от сервера;
        // отзыв сессии шлём с коротким таймаутом уже после.
        const refreshToken = localStorage.getItem('refreshToken');
        localStorage.removeItem('token');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('user_role');
        if (refreshToken) {
            try { await api.post('/api/logout', { refreshToken }, { timeout: 3000 }); } catch (e) { /* выходим в любом случае */ }
        }
        window.location.href = '/login';
    };

    useEffect(() => {
        const iconMenu = document.querySelector('.menu__icon');
        if (iconMenu) {
            const menuBody = document.querySelector('.nav');
            const headerMob = document.querySelector('.header');
            const tabs = document.querySelector('.tabs');
            const dropdown = document.querySelector('.dropdown');
            const filterIcon = document.querySelector('.filter__icon');
            const addicon = document.querySelector('.icon-add');
            const scannerForm = document.querySelector('.scannerform'); 
            const scannerPage = document.querySelector('.scanners-inv-seeds-page');
            const activeformvar = document.querySelector('.active-formvar'); 
            const seedsinvvariantsinner = document.querySelector('.seedsinv-variants-inner'); 
            const selectbox = document.querySelector('.select'); 
            const slct = document.querySelector('.slct');
            const dropContent = document.querySelector('.drop'); 
            const catcontainer = document.querySelector('.cat-container'); 
            const filter = document.querySelector('.filter'); 
            const tabscontainer = document.querySelector('.tabs-container'); 
            const scannersmenu = document.querySelector('.scanners-menu'); 
            const disabled = document.querySelector('.disabled'); 
            const scannerforminner = document.querySelector('.scannerform-inner');
            const scannerboxsetsinner = document.querySelector('.scan-sealed-sets');

            const handleMenuClick = (e) => {
                document.body.classList.toggle('lock');
                iconMenu.classList.toggle('active');
                headerMob.classList.toggle('active__nav');
                menuBody.classList.toggle('active');
                setOpenSubmenu(null);
    
                // Переключаем классы для плавного скрытия/появления
                const elementsToFade = [
                    tabs, dropdown, filterIcon, addicon, scannerForm, scannerPage, 
                    selectbox, slct, dropContent, catcontainer, filter, 
                    tabscontainer, scannersmenu, disabled, seedsinvvariantsinner, 
                    activeformvar, scannerforminner, scannerboxsetsinner
                ];
    
                elementsToFade.forEach((el) => {
                    if (el) {
                        if (menuBody.classList.contains('active')) {
                            el.classList.remove('fade-in');
                            el.classList.add('fade-out');
                        } else {
                            el.classList.remove('fade-out');
                            el.classList.add('fade-in');
                        }
                    }
                });

                // The notification bell / profile menu / admin panel have their
                // own open state, independent from the mobile nav. Without this,
                // closing the burger menu leaves them rendered on top of the page.
                window.dispatchEvent(new Event('header:closeMobileMenu'));
            };
    
            iconMenu.addEventListener('click', handleMenuClick);
    
            return () => {
                iconMenu.removeEventListener('click', handleMenuClick);
            };
        }
    }, []);

    return (
        <div className="header">
            <div className="container">
                <div className="header__login">
                    <div className="header__logo">
                        <img alt="Organo Republic" src={logo} />
                    </div>
                    <div className="menu__icon">
                        <span></span>
                    </div>
                    <div className="nav">
                        <nav className="nav__menu">
                            {MENU.map(item => {
                                if (item.children) {
                                    const visible = item.children.filter(child => can(child.page));
                                    if (visible.length === 0) return null;
                                    return (
                                        <div key={item.key} className={`menu nav__linkmenu ${openSubmenu === item.key ? 'is-open' : ''}`}>
                                            <div className="nav__linkmenu-row">
                                                <a className="nav__link" href={visible[0].href}>{item.label}</a>
                                                <button type="button" className="nav__submenu-toggle" onClick={(e) => { e.preventDefault(); toggleSubmenu(item.key); }}>
                                                    <FontAwesomeIcon icon={faChevronDown} />
                                                </button>
                                            </div>
                                            <div className={`sub-menu${item.wide ? ' sub-menu--wide' : ''}`}>
                                                {visible.map(child => (
                                                    <a key={child.page} className="sub-menu-link" href={child.href}>{child.label}</a>
                                                ))}
                                            </div>
                                        </div>
                                    );
                                }
                                return can(item.page)
                                    ? <a key={item.page} className="nav__link" href={item.href}>{item.label}</a>
                                    : null;
                            })}
                        </nav>
                        <div className="header__buttons">
                            {can('admin-users') && (
                                <a className="admin-panel-trigger" title="Admin" href="/admin/users">
                                    <FontAwesomeIcon icon={faGear} />
                                    <span className="admin-panel-trigger__label">Admin</span>
                                </a>
                            )}
                            {can('docs') && (
                                <a className="admin-panel-trigger" title="Documentation" href="/docs">
                                    <FontAwesomeIcon icon={faBookOpen} />
                                    <span className="admin-panel-trigger__label">Docs</span>
                                </a>
                            )}
                            {can('general') && <NotificationBell />}
                            <ProfileMenu onLogout={handleLogout} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HeaderLogged;